import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  AutoComplete, Input, Drawer, Tag, Select, Form
} from "antd";
import './LocationFilter.css';
import FilterRegion from "./region.Filter";
import { fetchKeySearchDynamicLocation } from "../../../../redux/actions";
import { indexOf } from "lodash";
const Region = ({ 
  emptyRegionInput,setEmptyRegionInput,
    setCheck, 
    check,
    setCheckRegionId,checkRegionId,
  setregionObj,
  regionObj,
  searchLocationFilter, city,country,fromCandMkt,
 }) => {
  const { Option } = Select;
  // const [locationValue, setLocationValue] = useState([]);
  const [visible, setVisible] = useState(false);
  const dispatch = useDispatch();
  // const filters = useSelector(state => state.searchSkillListingReducer.filters);
  const [selectedItems, setSelectedItems] = useState([]);
  const [valueCheck,setValueCheck] = useState(check.map(item => item.name))
  const [valueCheckId,setValueCheckId] = useState(check.map(item => item.id))

  const regionSuggestions = useSelector(
    (state) => state.searchSkillListingReducer.regionSuggestions
  );
  const locations = useSelector(
    (state) => state.searchSkillListingReducer.locations
  );
  const stateSuggestions = useSelector((state) => state.searchSkillListingReducer.stateSuggestions);
  const [isSelectVisible, setIsSelectVisible] = useState(false);
useEffect(()=>{
  setValueCheck(check.map(item => item.name))
  setValueCheckId(check.map(item => item.id))
},[check])
 

  const showDrawer = () => {
    setVisible(true);
    setIsSelectVisible(false);
  };

  const onClose = () => {
    setVisible(false);
    setIsSelectVisible(false);
  };

  
  // const valueCheck = check.map(item => item.name.replace(/\+/g, ' ')).join(', ');
  const valueId = check.map(item => item.id);

  const handleRegionChange = (flag) => {
    if (flag) {
      if (emptyRegionInput === "") {
        setEmptyRegionInput();
      }
    }
    if (!flag) {
      setEmptyRegionInput("");
    }
    setVisible(flag);
  };

  const containerStyle = {
    position: "relative",
    height: "100vh !important",
    overflow: "hidden",
    // textAlign: 'center',
  };

  useEffect(() => {
    if (
      check.length === 0 &&
      !visible &&
      country.length === 0 &&
      city.length === 0
    ) {
      const params = {
        body: searchLocationFilter,
      };
      dispatch(fetchKeySearchDynamicLocation(params))
    } else if(regionSuggestions.length == 0 && check.length > 0){
      searchLocationFilter.obj['RegionId'] = setValueCheckId
      const params = {
        body: searchLocationFilter,
      };
      dispatch(fetchKeySearchDynamicLocation(params));
    }
  },[visible])


  const handleDeselect=(deselectedValue)=>{
    const updatedValues = check.filter((value) => value.name!== deselectedValue);
    setCheck(updatedValues);
    setValueCheck(updatedValues)

    //for ids and checked values
    const deselectedIndex =  check.findIndex(value => value.name == deselectedValue)
    setCheckRegionId(checkRegionId.filter(((val,index) => index!== deselectedIndex))) 
  }

  return (
    <div className="search-location-filter-mobile">
      <Drawer
        className="location-drawer"
        onClose={onClose}
        visible={visible}
        closable={true}
        placement={"top"}
        afterOpenChange={(e) => {
          handleRegionChange(e);
        }}
        contentWrapperStyle={containerStyle}
        title={"Select state/states"}
      >
        <FilterRegion
          setregionObj={setregionObj}
          regionObj={regionObj}
          setcheck={setCheck}
          check={check}
          setCheckRegionId={setCheckRegionId}
          checkRegionId={checkRegionId}
          emptyRegionInput={emptyRegionInput}
          searchLocationFilter={searchLocationFilter}
          mobileFilter={true}
          setVisible={setVisible}
          fromCandMkt = {fromCandMkt ?? false}
        />
      </Drawer>
     
      {/* <Input className="input"
        value={valueCheck}
        onClick={showDrawer}
        type={'input'} placeholder="Search state" />  */}
           <Form>
      <Form.Item>
        <Select
         value={valueCheck}
          placeholder="Search state"
          className="input"
          mode="multiple"
          bordered={false}
          onDeselect={handleDeselect}
          onClick={showDrawer}
          showSearch
          listHeight={160}
          open={isSelectVisible}
        >
          </Select>
      </Form.Item>
    </Form>
    </div>
  );
};
export default Region;
